import api from './interceptor';

const BASE_URL_V2 = 'api/v2/patients';

export default {
  // API Version 2
  getSoapNotes: (patientId, params) => api.get(`${BASE_URL_V2}/${patientId}/soap-notes`, { params }),
  createSoapNote: (patientId, data) => api.post(`${BASE_URL_V2}/${patientId}/soap-notes`, data),
  postAnswers: ({ userId, answers }) => api.post(`${BASE_URL_V2}/${userId}/update-answers`, { answers }),
  getPatientQuestionnaire: (userId, params) => api.get(`${BASE_URL_V2}/${userId}/questions`, { params }),
  getPatientHandsfreeNotes: (patientId, params) => api.get(`${BASE_URL_V2}/${patientId}/notes`, { params }),
  getSignedPrescriptionPackets: (patientId) => api.get(`${BASE_URL_V2}/${patientId}/prescription-dme/signed-packets`),
  addPatientHandsfreeNotes: (patientId, params) => api.post(`${BASE_URL_V2}/${patientId}/notes`, params),
  editPatientHandsfreeNotes: (patientId, noteId, params) => api.patch(`${BASE_URL_V2}/${patientId}/notes/${noteId}`, params),
  deletePatientHandsfreeNotes: (patientId, noteId) => api.delete(`${BASE_URL_V2}/${patientId}/notes/${noteId}`),
  setDepartment: (patientId, params) => api.put(`${BASE_URL_V2}/${patientId}/department`, params),
  getAvailableQuestions: (patientId, params) => api.get(`${BASE_URL_V2}/${patientId}/available-questions`, { params }),
  getAssignedQuestions: (patientId) => api.get(`${BASE_URL_V2}/${patientId}/assigned-questions`),
  assignQuestions: (patientId, data) => api.post(`${BASE_URL_V2}/${patientId}/assigned-questions`, data),
  unassignQuestions: (patientId, data) => api({ method: 'DELETE', url: `${BASE_URL_V2}/${patientId}/assigned-questions`, data }),
};
